import './OnboardingPages.scss';

import React, {useEffect, useState} from 'react';
import HandicaddieLogo from "../../../icons/HandicaddieLogo";
import {Formik} from "formik";
import {useLocation, useNavigate} from "react-router-dom";
import * as yup from "yup";
import {CredentialsService} from "../../../services/api/CredientialsService";
import {FORGOT_PASSWORD_EMAIL, LOGIN} from "../../../services/PageUtils";
import ErrorText from "../../../components/ErrorText";
import FormContainer from "../components/FormContainer";
import ErrorBox from "../components/ErrorBox";
import Button from "../../../components/Button";

interface Props {

}

const ResetPassword = ({}: Props) => {

    const navigate = useNavigate();
    const location: any = useLocation();

    const {updateCredentials} = CredentialsService()

    const [errMsg, setErrMsg] = useState<string>();
    const [loading, setLoading] = useState(false);

    const schema = yup.object().shape({
        password: yup.string()
            .required("Password is required")
            .matches(/^(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).*$/,
                "Password should contain, at least: 8 characters, 1 uppercase letter, 1 lowercase letter, 1 number"),
        passwordConfirmation: yup
            .string()
            .required("Password confirmation is required")
            .oneOf([yup.ref("password")], "Passwords must match"),
        code: yup.string().required("Code is required")
    });

    useEffect(() => {
        setLoading(false);

        if (!location.state || !location.state.email) {
            // navigate(FORGOT_PASSWORD_EMAIL)
        }
    }, []);

    const submitForm = async (values: any) => {
        setLoading(true);
        setErrMsg(undefined);

        const resp = await updateCredentials({
            email: location.state.email,
            password: values.password
        }, values.code)
        setLoading(false);

        if (resp.error) {
            setErrMsg(resp.error.message);
            return;
        }

        navigate(LOGIN);
    };


    return (
        <FormContainer>
                <div className={"header_logoContainer"}>
                    <HandicaddieLogo size={'lg'}/>
                </div>

                <span className={"heading"} style={{ alignSelf: 'flex-start' }}>Reset Your Password</span>

                <Formik
                validationSchema={schema}
                onSubmit={submitForm}
                initialValues={{
                    email: "",
                    password: "",
                    passwordConfirmation: "",
                    code: ""
                }}
            >
                {({
                      handleSubmit,
                      handleChange,
                      handleBlur,
                      values,
                      touched,
                      isValid,
                      errors,
                  }) => (
                    <form onSubmit={handleSubmit}>
                        <h3 className={"onboarding_label"}>Email</h3>
                        <input
                            className="onboarding_input"
                            type="email"
                            name="email"
                            placeholder=""
                            value={location?.state?.email}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            disabled={true}
                        />

                        <h3 className={"onboarding_labelWithExplanation"}>Code</h3>
                        <span className={"onboarding_explanation"}>
                            If you have an account, we have sent you a code to the email above, please enter that code here.
                        </span>
                        <div style={{marginTop: '0.25em'}}>
                            <input
                                required
                                className="onboarding_input"
                                type="numeric"
                                name="code"
                                placeholder="Code"
                                value={values.code}
                                onBlur={handleBlur}
                                onChange={handleChange}
                            />
                            {touched.code && errors.code && (
                                <ErrorBox text={errors.code} />
                            )}
                        </div>

                        <h3 className={"onboarding_labelWithExplanation"}>Password</h3>
                        <span className={"onboarding_explanation"}>
                            Now you can enter in your new password for your account.
                        </span>
                        <div style={{marginTop: '0.25em'}}>
                            <input
                                required
                                className="onboarding_input"
                                type="password"
                                name="password"
                                placeholder="Password"
                                value={values.password}
                                onBlur={handleBlur}
                                onChange={handleChange}
                            />
                            {touched.password && errors.password && (
                                <ErrorBox text={errors.password} />
                            )}
                        </div>
                        <div style={{marginTop: '0.25em'}}>
                            <input
                                required
                                className="onboarding_input"
                                type="password"
                                name="passwordConfirmation"
                                placeholder="Password Confirmation"
                                onBlur={handleBlur}
                                value={
                                    values.passwordConfirmation
                                }
                                onChange={handleChange}
                            />
                            {touched.passwordConfirmation && errors.passwordConfirmation && (
                                <ErrorBox text={errors.passwordConfirmation} />
                            )}
                        </div>


                        <ErrorBox text={errMsg} />

                        <div style={{ marginTop: '1.5em' }}>
                            <Button text={"RESET PASSWORD"} type="submit" disabled={loading} />
                        </div>
                    </form>
                )}
            </Formik>
        </FormContainer>
    )
}

export default ResetPassword;